import { Outlet } from 'react-router';

import { PreviewPolicyModal } from './Modals/PreviewPolicyModal';
import { NotesDrawer } from './Molecules/NotesDrawer';

export function OrganisationRoot() {
  return (
    <>
      <PreviewPolicyModal />
      { /* Inside the :organisationId route so the notes hooks can read organisationId from useParams */ }
      <NotesDrawer />
      <Outlet />
    </>
  );
}
